module.exports = __webpack_public_path__ + "img/cns_printer_mac30.9f6b4b39.png";